import React, { useState, useEffect } from 'react';
import { doLogin, doLogout, me } from '../services/authSvc';

export const AuthContext = React.createContext({});

export const Auth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
      if (isLoading) {
          setTimeout(async () => await checkAuth(), 200);
      }
  }, [isLoading]);

  const meCheck = async () => {
    await me();
    setIsAuthenticated(true);
  }

  const checkAuth = async () => {
    try {
      await meCheck();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  };

  const login = async (username, password) => {
    try {
      await doLogin(username, password);
      await meCheck();
    } catch (error) {
      console.error(error);
      setIsAuthenticated(false);
    }
  };

  const logout = () => {
    doLogout();
    setIsAuthenticated(false);
  };

  return <AuthContext.Provider value={{ isAuthenticated, isLoading, login, logout }}>{children}</AuthContext.Provider>;
};
